"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingService = exports.TrackingService = void 0;
var logger_1 = require("../../utils/logger");
var connection_aem_tracking_1 = require("@owc/connection-aem-tracking");
var removeEmTags = function (str) { return (str ? str.replace(/<em>/g, '').replace(/<\/em>/g, '') : ''); };
var TrackingService = /** @class */ (function () {
    function TrackingService() {
        this.isAemEnvironment = false;
        this.eventAction = 'fss_search_header'; //fss_search_inpage
        this.application = {
            id: '',
            version: '',
        };
    }
    TrackingService.prototype.getIsAemEnvironment = function () {
        return this.isAemEnvironment;
    };
    TrackingService.prototype.setAemEnviroment = function () {
        this.isAemEnvironment = true;
    };
    TrackingService.prototype.setApplication = function (application, action) {
        this.application = application;
        this.eventAction = action;
    };
    TrackingService.prototype.searchResultClicked = function (_a) {
        var url = _a.url, domain = _a.domain, index = _a.index, query = _a.query, _b = _a.autocomplete, autocomplete = _b === void 0 ? '' : _b;
        logger_1.logger.log('PushEvent searchResultClicked');
        var data = {
            event: 'click',
            eventDetail: {
                category: 'search',
                action: this.eventAction,
                label: 'search_result_selected',
                URL: removeEmTags(url),
                index: index,
                search: { domain: domain, autocomplete: autocomplete, term: query },
            },
            application: __assign(__assign({}, this.application), { parentApplicationId: this.isAemEnvironment ? 'aem' : 'emh' }),
        };
        this.pushEvent(data);
        return data;
    };
    TrackingService.prototype.searchExecuted = function (_a) {
        var term = _a.term, _b = _a.numResults, numResults = _b === void 0 ? '' : _b, _c = _a.typedQuery, typedQuery = _c === void 0 ? '' : _c;
        logger_1.logger.log('PushEvent searchExecuted');
        var search = {
            results: numResults,
            term: typedQuery ? typedQuery : term,
            autocomplete: typedQuery ? term : '',
        };
        var eventToBePushed = {
            event: 'click',
            eventDetail: {
                category: 'search',
                action: this.eventAction,
                label: 'search_executed',
                search: search,
            },
            application: __assign(__assign({}, this.application), { parentApplicationId: this.isAemEnvironment ? 'aem' : 'emh' }),
        };
        this.pushEvent(eventToBePushed);
        return eventToBePushed;
    };
    TrackingService.prototype.pushEvent = function (eventToBePushed) {
        logger_1.logger.log("Send a click event to the tracker: ".concat(JSON.stringify(eventToBePushed)));
        if (this.isAemEnvironment) {
            (0, connection_aem_tracking_1.getTrackingDispatchers)()
                .then(function (dispatchers) {
                logger_1.logger.log("AEM Event pushed ".concat(JSON.stringify(eventToBePushed)));
                dispatchers.pushTrackingEvent(eventToBePushed);
            })
                .catch(function (err) {
                logger_1.logger.log('Fail to send tracking', err);
            });
        }
        else {
            try {
                logger_1.logger.log("STANDALONE Event pushed");
                window.dataLayer_ow.push(eventToBePushed);
            }
            catch (err) {
                logger_1.logger.log(err);
            }
        }
    };
    return TrackingService;
}());
exports.TrackingService = TrackingService;
exports.trackingService = new TrackingService();
